export interface TaskTypeInstruction {
  greeting: string;
  questions: string[];
}

export const TASK_TYPE_INSTRUCTIONS: Record<string, TaskTypeInstruction> = {
  epic: {
    greeting:
      'Hi 👋,\nLet me help you with your Epic description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What is the main goal or outcome this Epic should achieve?',
      'Why is this Epic important for the product or business at this stage?',
      'What major deliverables or milestones should be completed within this Epic?',
    ],
  },
  task: {
    greeting:
      'Hi 👋,\nLet me help you with your Task description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What specific work or action needs to be done in this Task?',
      'What is the purpose or expected result of completing it?',
      'Are there any dependencies or resources required to perform this Task?',
    ],
  },
  bug: {
    greeting:
      'Hi 👋,\nLet me help you with your Bug description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What is the exact issue or unexpected behaviour you observed?',
      'What should have happened instead (expected behaviour)?',
      'How can this bug be reproduced (steps, environment, or conditions)?',
    ],
  },
  story: {
    greeting:
      'Hi 👋,\nLet me help you with your Story description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'Who is the user or role benefiting from this Story, and what do they want to achieve?',
      'What specific functionality or behaviour should be implemented to satisfy this goal?',
      'What outcome or result will confirm that this Story is successfully completed?',
    ],
  },
  feature: {
    greeting:
      'Hi 👋,\nLet me help you with your Feature description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What new capability or value does this Feature introduce for users?',
      `How should the feature behave or function from the user's perspective?`,
      'Are there any constraints, integrations, or dependencies that need to be considered?',
    ],
  },
  improvement: {
    greeting:
      'Hi 👋,\nLet me help you with your Improvement description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'Which existing part of the product are you looking to improve?',
      'What limitation or issue does the current solution have?',
      'What specific change or outcome would define success for this Improvement?',
    ],
  },
  experiment: {
    greeting:
      'Hi 👋,\nLet me help you with your Experiment description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What hypothesis or idea are you trying to test with this Experiment?',
      'What approach or method will be used to test it (e.g., A/B test, prototype, etc.)?',
      'What result or metric will determine whether the Experiment is successful?',
    ],
  },
  idea: {
    greeting:
      'Hi 👋,\nLet me help you with your Idea description!\n\nFeel free to explain what this Task is about however you wish, but something that would be useful for me to know is:',
    questions: [
      'What is the core idea or concept you want to explore?',
      'What problem, need, or opportunity does this idea address?',
      'How do you imagine this idea could add value to users or the product?',
    ],
  },
  universal: {
    greeting: `It looks like this Task already has a description.\nLet's review and refine it together to make sure it's clear, complete, and aligned with its purpose.\n\nYou can tell me what needs to be improved, clarified, or expanded, and I'll update the description accordingly.`,
    questions: [],
  },
};

export const getTaskTypeInstruction = (taskType: string, hasDescription: boolean): TaskTypeInstruction => {
  if (hasDescription) {
    return TASK_TYPE_INSTRUCTIONS.universal;
  }

  const normalizedType = taskType.toLowerCase();
  return TASK_TYPE_INSTRUCTIONS[normalizedType] || TASK_TYPE_INSTRUCTIONS.task;
};
